
import { Component } from 'vue-property-decorator'
import { ProductApiModel } from '@/interfaces/ProductApiModel.js'
import ProductRenderer from '@/components/product/ProductRenderer.vue'
import { namespace } from 'vuex-class'
import lodash from 'lodash'
import { mixins } from 'vue-class-component'
import { ModifiedModels } from '@/mixins/ModifiedModels'
const allModels = namespace('allModels')
const globalValues = namespace('globalValues')

@Component({
  components: {
    ProductRenderer
  }
})
export default class Designs extends mixins(ModifiedModels) {
  async mounted() {
    await this.loadModels({ ...this.model.configurator })
    await this.createModifiedModels()
    this.loaded = true
  }

  public loaded = false;

  private modelProperties = [
    'configurator.depth',
    'configurator.countertopCategory',
    'configurator.countertop',
    'configurator.edgeProfile',
    'configurator.overhang',
    'configurator.faucet',
    'configurator.sink'
  ];

  public selectModel(data: ProductApiModel): void {
    if (this.model.code !== data.code) {
      this.updateModelProperty({
        property: 'sinkOffset',
        value: data.configurator.sinkOffset
      })
      this.updateModelProperty({
        property: 'doubleSink',
        value: data.configurator.doubleSink
      })
      this.updateModelProperty({ property: 'height', value: data.configurator.height })
      this.updateModelProperty({ property: 'configuration', value: data.configurator.configuration })

      this.updateModelProperty({ property: 'panelFinish', value: data.configurator.panelFinish })
      this.updateModelProperty({ property: 'panelFinishCategory', value: data.configurator.panelFinishCategory })
      this.updateModelProperty({ property: 'metalFinish', value: data.configurator.metalFinish })
      this.updateModelProperty({ property: 'metalFinishCategory', value: data.configurator.metalFinishCategory })
      this.updateModelProperty({ property: 'hardware', value: data.configurator.hardware })
      this.updateModelProperty({ property: 'accent', value: data.configurator.accent })
      this.updateModelProperty({ property: 'legHardware', value: data.configurator.legHardware })
      this.updateModelProperty({ property: 'hardwareFrames', value: data.configurator.hardwareFrames })
      this.updateModelProperty({ property: 'accentFrames', value: data.configurator.accentFrames })
      this.updateModelProperty({ property: 'legHardwareFrames', value: data.configurator.legHardwareFrames })
      this.updateModelProperty({ property: 'base', value: data.configurator.base })

      const routeName = this.$route.name ?? 'Size & Configuration'

      this.$router.push({
        name: routeName,
        params: { productCode: data.code }
      })
    }
  }

  @globalValues.Action
  public hidePopover!: () => Promise<boolean>;

  @allModels.State
  public models!: Array<ProductApiModel>;

  @allModels.Action
  public loadModels!: (conf: any) => Promise<boolean>;

  public async createModifiedModels() {
    const basicConf = lodash.pick(this.model, this.modelProperties)

    for (const modelToMerge of this.models) {
      const newModel = lodash.merge(modelToMerge, basicConf) as ProductApiModel

      await this.addModifiedModel(newModel, false, false)
    }
  }
}
